export default {
    quoteLoading: state => state.quoteLoading,
    quoteDetailLoading: state => state.quoteDetailLoading,
    quoteDetails: state => state.quoteDetails,
}